import type {
  Course,
  CourseTypes,
  ModalityTypes,
} from '@/models/catalog/course';
import { CourseSourceTypes, type EmbeddedCourse } from '@/models/resources';

export const mapCatalogCourseToEmbeddedCourse = (
  catalogCourse: Course
): EmbeddedCourse => {
  return {
    id: String(catalogCourse.id),
    institution_name: catalogCourse.institution.name || '',
    institution_id: catalogCourse.institution.id,
    name: catalogCourse.course_name,
    modality: catalogCourse.modalities[0].type as ModalityTypes,
    course_type: catalogCourse.course_type?.type as CourseTypes,
    source: CourseSourceTypes.CatalogGalena,
    external_course_url: null,
    external_course_id: String(catalogCourse.id) || null,
    external_offer_id: String(catalogCourse.offer_id) || null,
    external_institution_logo_url: catalogCourse.institution.logo_url,
    external_institution_background_color:
      catalogCourse.institution.logo_background_color || null,
    duration: catalogCourse.duration?.quantity,
    duration_type: catalogCourse.duration?.type,
    about: catalogCourse.course_name,
  };
};
